import { useSchema as useBaseSchema } from '../../sharedSchemaFragments/nlpSettings/hooks/useSchema'

export function useSchema() {
  return useBaseSchema().properties.models.items
}
